import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CurrencyModel } from '../models/currency.model';

export class CurrenciesApiService extends ApiService {
  static endpoint = 'currencies';

  /**
   * @param {Number|null} currencyId
   * @return {String}
   * @protected
   */
  static buildCurrencyUrl(currencyId = null) {
    return this.buildUrl(currencyId);
  }

  /**
   * @param {String|Number} currencyId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CurrencyModel>>}
   * @public
   */
  static async get(currencyId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCurrencyUrl(currencyId), {
      ...config,
      dataModel: CurrencyModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} currencyId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CurrencyModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCurrencyUrl(), {
      ...config,
      dataModel: CurrencyModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CurrencyModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildCurrencyUrl(), data, {
      ...config,
      dataModel: CurrencyModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} currencyId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CurrencyModel>>}
   * @public
   */
  static async patch(currencyId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildCurrencyUrl(currencyId), data, {
      ...config,
      dataModel: CurrencyModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} currencyId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(currencyId, config = {}) {
    return HttpApiClient.delete(this.buildCurrencyUrl(currencyId), { ...config });
  }
}
